<!-- modal status -->
<ng-template #modal let-modal class="modal-dialog-centered">
    <div class="modal-header">
        <h4 class="modal-title text-center w-100" id="modalLabel">{{ 'SETTINGS.STATUS.EDITSTATUS' | translate }}</h4>
        <button type="button" class="btn-close" tabindex="-1" aria-label="Close" (click)="closeModal()">
        </button>
    </div>
    <div class="modal-body p-1">
        <div *ngIf="loading" class="row" style="height: 30px">
            <app-ui-preloader id="spinner" [display]="loading" [size]="'20px'"></app-ui-preloader>
        </div>

        <form *ngIf="!loading" [formGroup]="statusForm" class="p-2 mt-n2 form">
            <div class="row">
                <div class="col-md-12">
                    <div class="mb-1">

                        <label class="form-label">{{ 'SETTINGS.STATUS.TYPE' | translate }}</label>
                        <input type="text" class="form-control" id="field-3" formControlName="Type" [readonly]="true">
                    </div>
                    <div class="mt-2">
                        <div class="form-check form-switch">
                            <input type="checkbox" formControlName="FinalState" class="form-check-input form-control check-padding">
                            <label class="form-label">{{ 'SETTINGS.STATUS.FINALSTATE' | translate }}</label>
                        </div>
                    </div>
                </div>
            </div>
        </form>

        <!-- <div *ngIf="!loading" id="tab" class="col-md-12">
            <ul ngbNav #tab="ngbNav" [(activeId)]="tabsStatus" class="nav-tabs nav-bordered">
                <ng-container *ngFor="let language of languages; let i = index">
                    <li [ngbNavItem]="i+1">
                        <a ngbNavLink>
                            {{language.description}}
                        </a>

                        <ng-template ngbNavContent>
                            <ng-container *ngTemplateOutlet="language.locale=='pt'?Tab1:Tab2">
                            </ng-container>
                        </ng-template>
                    </li>
                </ng-container>

            </ul>

            <div [ngbNavOutlet]="tab"></div>
        </div> -->
        <div  *ngIf="!loading">
            <ng-template ngbNavContent>
                <ng-container *ngTemplateOutlet="Tab2">
                </ng-container>
            </ng-template>
        </div>

        <!-- <ng-template #Tab1>
            <form [formGroup]="statusForm" class="p-2 mt-n2 form">
                <div class="row">
                    <div class="col-md-12">
                        <div class="mb-2">

                            <label for="field-3" class="form-label">{{ 'SETTINGS.STATUS.STATUS' | translate }}</label>
                            <input type="text" class="form-control" id="field-3" formControlName="StatusPT"
                                [readonly]="true">
                        </div>
                        <div class="mb-2">

                            <label class="form-label">{{ 'SETTINGS.STATUS.CUSTOMERSTATUS' | translate }}</label>
                            <input type="text" class="form-control" formControlName="CustomerStatusPT"
                                [ngClass]="{'is-invalid':submitted && formStatus.CustomerStatusPT.invalid}" required>

                            <div *ngIf="submitted && formStatus.CustomerStatusPT.invalid" class="invalid-feedback">
                                <div *ngIf="formStatus.CustomerStatusPT.errors?.required" i18n>
                                    {{ 'SETTINGS.STATUS.CUSTOMERSTATUSREQUIRED' | translate }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </ng-template> -->

        <ng-template #Tab2>
            <form [formGroup]="statusForm" class="p-2 mt-n2 form">
                <div class="row">
                    <div class="col-md-12">
                        <div class="mb-2">
                            <label class="form-label">{{ 'SETTINGS.STATUS.STATUS' | translate }}</label>
                            <input type="text" class="form-control" formControlName="StatusEN" [readonly]="true">
                        </div>
                        <div class="mb-2">
                            <label class="form-label">{{ 'SETTINGS.STATUS.CUSTOMERSTATUS' | translate }}</label>
                            <input type="text" class="form-control" formControlName="CustomerStatusEN"
                                [ngClass]="{'is-invalid':submitted && formStatus.CustomerStatusEN.invalid}" required>

                            <div *ngIf="submitted && formStatus.CustomerStatusEN.invalid" class="invalid-feedback">
                                <div *ngIf="formStatus.CustomerStatusEN.errors?.required" i18n>
                                    {{ 'SETTINGS.STATUS.CUSTOMERSTATUSREQUIRED' | translate }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </ng-template>

    </div>

    <div class="mt-2 mb-2 d-flex justify-content-center">
        <button class="btn btn-primary waves-effect waves-light btnSaveBottom btnSaveMinW2"
            [disabled]="loading" (click)="save()">
            {{'MISC.SAVE'| translate}}
        </button>
    </div>
</ng-template>